module.exports = __webpack_public_path__ + "gu.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/gu.svg
// module id = 585
// module chunks = 0